import React, { useEffect, useRef, useState } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Radio,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  FinUpdateAccountAggregatorCreateConsentAPICall,
  GetIncomeProofAPICall,
  GetIncomeSlabAPICall,
  SubmitDetailsAPICall,
  deleteDocumentAPICall,
  stageDetailsAPICall,
  uploadDocumentsAPICall,
} from "./APICalls";
import uploadStyles from "./Uploads.module.scss";
import SnackBar from "../../Components/SnackBars/SnackBar";
import SucessSnackBar from "../../Components/SnackBars/SucesssnackBar";
import { getCookie } from "./cookies";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import BackDrop from "../../Components/BackDrop";
import ChecklistDone from "../../Components/assets/Images/ChecklistDone.svg";
import ChecklistEmpty from "../../Components/assets/Images/ChecklistEmpty.svg";
import incomeicon from "../../Components/assets/Images/incomeicon.svg";
import FormatterCheckerFinUpdate from "../FormatCheckerFinupdate";
import keyboardicon from "../../Components/assets/Images/panicongrey.svg";
import { isMobile } from "react-device-detect";
import uploadwhiteicon from "../../Components/assets/Images/uploadwhiteicon.svg";
import uploadblueicon from "../../Components/assets/Images/uploadblueicon.svg";
import repeat from "../../Components/assets/Images/repeat.svg";
import repeatblue from "../../Components/assets/Images/repeaticonblue.svg";
import { REDIRECTURL } from "../../shared/constants";
import { SaveIpAddressAPICall } from "../../shared/APICalls";

export default function UploadDocumentsPageFinUpdate() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [completedStages, setcompletedStages] = useState(50);

  const [incomeProofUrl, setincomeProofUrl] = useState<any>();

  const [checkedOptions1, setCheckedOptions1] = useState(false);
  const [checkedOptions2, setCheckedOptions2] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [displayFile, setDisplayFile] = useState({
    status: false,
    type: "",
  });

  const [incomeSlabDropdown, setIncomeSlabDropdown] = useState([]);
  const [incomeProofDropdown, setIncomeProofDropdown] = useState([]);
  const [incomeslabValue, setIncomeslabValue] = useState({
    value: "",
    sequence: 0,
  });
  const [incomesproofValue, setIncomesproofValue] = useState({
    document_type_reference: "",
    value: "",
    sequence: 0,
  });
  const [incomeSlabAPIValue, setIncomeSlabAPIValue] = useState("");
  const [fileUploadedStatus, setFileUploadedStatus] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const userId = getCookie("userId");
  // const userId = "NP2997";
  const latitude = sessionStorage.getItem("latitude");
  const longitude = sessionStorage.getItem("longitude");
  const [bgColor1, setbgcolor1] = useState("#006779");
  const [bgColor2, setbgcolor2] = useState("#E1E2E3");
  const [selectedValue, setSelectedValue] = useState("a");
  const [disableContinueOption1, setdisableContinueOption1] = useState("");
  const [uploadmessage, setUploadmessage] = useState("");
  const [fetchLodaing, setFetchLoading] = useState(false);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [fetchIncomeLoading, setFetchIncomeLoading] = useState(false);
  const [optional, setOptional] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);

  const timerRef = useRef<any>(null);
  const requestID: any = sessionStorage.getItem("finupdateRequestID");

  const formats: any = ["pdf", "png", "jpg", "jpeg"];

  useEffect(() => {
    window.scrollTo(0, 0);

    GetIncomeSlabDropDown();
    GetIncomeProofDropDown();
  }, []);

  const handleChange = (event: any) => {
    setIncomesproofValue(event.target.value);
    if (event.target.value.document_type_reference === "bank_statement") {
      setSelectedValue("a");
    } else {
      setSelectedValue("b");
    }
  };

  const GetIncomeSlabDropDown = () => {
    let obj: any = {
      doc_type: "annual_income",
    };
    GetIncomeSlabAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        if (response.data.data.annual_income) {
          const FilteredIncomeSlab = response.data.data.annual_income.sort(
            (a: any, b: any) => a.sequence - b.sequence
          );
          setIncomeSlabDropdown(FilteredIncomeSlab);
          setIncomeslabValue(FilteredIncomeSlab[0]);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const GetIncomeProofDropDown = () => {
    let obj: any = {
      doc_type: "document_type",
    };
    GetIncomeProofAPICall(obj)
      .then((response: any) => {
        if (response.data.data.income_proof) {
          const FilteredIncomeProof = response.data.data.income_proof.sort(
            (a: any, b: any) => a.sequence - b.sequence
          );
          setIncomeProofDropdown(FilteredIncomeProof);
          setIncomesproofValue(FilteredIncomeProof[0]);
          handleStageAPI(FilteredIncomeProof);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const SubmitDetails = () => {
    SubmitAllDetails();
  };

  useEffect(() => {
    if (childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef]);

  function checkChild() {
    // console.log("timer");

    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);

      setFetchLoading(false);
      setFetchIncomeLoading(false);
      handleStageAPI(incomeProofDropdown);
    }
  }

  const SubmitAllDetails = () => {
    let obj: any = {
      // client_code: userId,
      request_id: requestId,
      income_slab_value: incomeslabValue.value,
      is_t_and_c_selected: true,
    };

    SubmitDetailsAPICall(obj)
      .then((response: any) => {
        setopenSuccessModal(true);
        const responseData = response.data;
        SaveIpAddress(responseData);
        // navigate("/finupdate/completed");
        setRejectMessage("");
        setcompletedStages(100);
      })
      .catch((error: any) => {
        // console.log("error", error);
        seterrorMessage("Error Submiting the Details");
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const SaveIpAddress = (responseData: any) => {
    let obj: any = {
      request_id: responseData?.data.request_id
        ? responseData?.data.request_id
        : requestId,
      update_component: "financial_update",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("longitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        if (responseData.next_stage === "congratulations") {
          navigate("/finupdate/completed");
        } else {
          navigate("/finupdate/completed");
        }
      })
      .catch((error: any) => {
        seterrorMessage(error?.response?.data?.message);
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const handleStageAPI = (FilteredIncomeProof: any) => {
    let obj: any = {
      stage: "income_details",
      request_id: requestId,
    };
    setloading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("incomeProofDropdown", response.data.data.stage_values);
        setloading(false);
        if (response.data.data.request_id) {
          setRequestId(response?.data?.data.request_id);
          sessionStorage.setItem(
            "finupdateRequestID",
            response?.data?.data.request_id
          );
        }

        if (response.data.data.error_msg) {
          setRejectMessage(response.data.data.error_msg);
        }

        if (response.data.data.stage_values?.income_slab) {
          setIncomeslabValue({
            value: response.data.data.stage_values?.income_slab,
            sequence: 0,
          });
        }
        if (response.data.data.stage_values?.is_fo_selected === false) {
          setOptional(true);
          setdisableContinueOption1("Successfully uploaded the document");
        }

        if (response.data.data.stage_values.doc_val !== "") {
          setincomeProofUrl(response.data.data.stage_values.doc_val);
          setFileUploaded(true);
          setdisableContinueOption1("Successfully uploaded the document");
          setFileUploadedStatus(true);
          const prooftype = FilteredIncomeProof?.filter(
            (a: any) =>
              a.document_type_reference ===
              response.data.data.stage_values.doc_val?.doc_type_ref
          );
          // console.log(
          //   "FilteredIncomeProof",
          //   FilteredIncomeProof,
          //   "prooftype",
          //   prooftype
          // );
          setIncomesproofValue(prooftype[0]);
          // setDisplayFile({
          //   status: true,
          //   type: response.data.data.doc_type_ref,
          // });

          // if (response.data.data.doc_type_ref === "bank_statement") {
          //   setSelectedValue("b");
          // } else {
          //   setSelectedValue("b");
          // }
        } else {
          setFileUploadedStatus(false);
          // setDisplayFile({
          //   status: false,
          //   type: "",
          // });
        }
        if (response.data.data.isApproved) {
          setopenSuccessModal(true);
          navigate("/finupdate/approved");
          setcompletedStages(100);
        } else if (response.data.data.isCompleted) {
          setopenSuccessModal(true);
          navigate("/finupdate/completed");
          setcompletedStages(100);
        }

        if (
          response.data.data.annual_income_value &&
          response.data.data.annual_income_value !== ""
        ) {
          setIncomeSlabAPIValue(response.data.data.annual_income_value);
        }
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);
      });
  };

  useEffect(() => {
    if (displayFile.type !== "") {
      const filteredIncomeProof: any = incomeProofDropdown.filter(
        (a: any) => a.value === displayFile.type
      );

      setIncomesproofValue(filteredIncomeProof[0]);
    }
    if (incomeSlabAPIValue !== "") {
      const filteredIncomeSlab: any = incomeSlabDropdown.filter(
        (a: any) => a.value === incomeSlabAPIValue
      );

      setIncomeslabValue(filteredIncomeSlab[0]);
    }
  }, [displayFile, incomeSlabAPIValue]);

  const handlePreview = (data: any) => {
    //console.log(data);
  };

  const handleDocumentID = (data: any) => {
    console.log("documentID", data);

    setUploadmessage(data);
    if (data !== "") {
      setFileUploaded(true);
      if (optional) {
        setdisableContinueOption1("Successfully uploaded the document");
      } else{
        setdisableContinueOption1("Successfully uploaded the document");
      }
    } else {
      setFileUploaded(false);
      if (optional) {
        setdisableContinueOption1("Successfully uploaded the document");
      } else {
        setdisableContinueOption1(data);
      }
    }

    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
    if (data === "") {
      setincomeProofUrl(null);
    }
  };

  const handleOpenClickIncomeProof = () => {
    setFetchIncomeLoading(true);
    let digilink: string = "";

    let obj: any = {
      request_id: requestId,
      callback_url: `${REDIRECTURL}finupdate/account_aggregator`,
    };

    FinUpdateAccountAggregatorCreateConsentAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        if (response.data.data.request_id) {
          setRequestId(response?.data?.data.request_id);
          sessionStorage.setItem(
            "finupdateRequestID",
            response?.data?.data.request_id
          );
        }

        digilink = responseData.data.link;

        window.location.href = digilink;
      })
      .catch((error: any) => {
        setFetchIncomeLoading(false);
      });
  };

  const displayButton =
    selectedValue === "a"
      ? true
      : disableContinueOption1 === "Successfully uploaded the document"
      ? true
      : false;

  // console.log(

  //   "disableContinueOption1",
  //   disableContinueOption1
  // );

  return (
    <div className={uploadStyles.mainWrapperTop}>
      <SucessSnackBar message={uploadmessage} />
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />

      {loading && <BackDrop />}

      <div className={uploadStyles.wrapper}>
        <div className={uploadStyles.step}>
          <img src={keyboardicon} /> Step 1 of 2
        </div>

        <div className={uploadStyles.headerSection}>
          <p className={uploadStyles.signup}>Upload Income Details</p>
        </div>

        <>
          <div className={uploadStyles.uploaddropdownWrapper}>
            <div className={uploadStyles.thList}>
              <p className={uploadStyles.incomeSlab}>Income Slab</p>

              <div className={uploadStyles.chipsWrapper}>
                {incomeSlabDropdown &&
                  incomeSlabDropdown.map((a: any) => (
                    <div
                      className={uploadStyles.chip}
                      onClick={(event) => {
                        setIncomeslabValue(a);
                      }}
                      style={{
                        background:
                          incomeslabValue?.value === a.value ? "" : "none",
                        border:
                          incomeslabValue.value === a.value
                            ? ""
                            : "1px solid #EBECEF",
                      }}
                    >
                      <img
                        src={
                          incomeslabValue.value === a.value
                            ? ChecklistDone
                            : ChecklistEmpty
                        }
                        className={uploadStyles.checkicon}
                        alt=""
                      />
                      <p
                        className={uploadStyles.checkLabel}
                        style={{
                          color:
                            incomeslabValue.value === a.value ? "" : "#6B7280",
                        }}
                      >
                        {a.value}
                      </p>
                    </div>
                  ))}
              </div>
            </div>

            <div className={uploadStyles.uploadSection}>
              <FormControl>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0px 3px",
                    gap: "5px",
                    fontSize: { xs: "12px", sm: "17px" },
                    color: "var(--Red-Black-Black-900, #111827)",
                    marginTop: { xs: "-12px", sm: "0px" },
                    width:"max-content",
                    maxWidth:"unset"
                  }}
                >
                  <img src={incomeicon} style={{ width: "20px" }} />
                  Income Proof {optional ? "(Optional)" : ""}
                </InputLabel>

                <Select
                  //  style={{ width: "300px", margin: "25px !important" }}
                  className={uploadStyles.uploadSectionSelectDropDown}
                  disableUnderline
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                    color: "#6B7280",
                    fontSize: "14px",
                  }}
                  MenuProps={{
                    MenuListProps: {
                      sx: {
                        "& li.Mui-selected": {
                          backgroundColor: "#1F2937",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#1F2937",
                          },
                        },
                      },
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={incomesproofValue}
                  label="Select Proof Type"
                  onChange={handleChange}
                  disabled={fileUploaded}
                >
                  {incomeProofDropdown.map((data: any, index: any) => {
                    // console.log(data)
                    return (
                      <MenuItem
                        value={data}
                        key={index}
                        sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                      >
                        {data.value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <div className={uploadStyles.buttonssectionpan}>
                {incomesproofValue?.value ===
                  "Bank account statement for last 6 months" &&
                  !fileUploaded &&
                  !incomeProofUrl && (
                    <LoadingButton
                      variant="contained"
                      component="label"
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column-reverse", sm: "row" },
                        height: { xs: "max-height", sm: "35px" },
                        color: { xs: "#3263E5", sm: "white" },
                        borderRadius: "20px",
                        boxShadow: "none",
                        fontSize: "12px",
                        background: { xs: "white", sm: "#3263E5" },
                        "&:hover": {
                          background: { xs: "white", sm: "#3263E5" },
                        },
                      }}
                      onClick={handleOpenClickIncomeProof}
                      loading={fetchIncomeLoading}
                    >
                      <span>VerifyOnline</span>{" "}
                      <img
                        src={isMobile ? repeatblue : repeat}
                        width={"20px"}
                      />
                    </LoadingButton>
                  )}
                {incomesproofValue?.value ===
                  "Bank account statement for last 6 months" &&
                  !fileUploaded &&
                  !incomeProofUrl && (
                    <span
                      style={{ fontSize: "19px", color: "#E5E7EB" }}
                      className={uploadStyles.buttonDivider}
                    >
                      |
                    </span>
                  )}

                <>
                  <FormatterCheckerFinUpdate
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={incomesproofValue?.value}
                    documentID={handleDocumentID}
                    displayOptions={() => {}}
                    stageDetailsData={incomeProofUrl}
                    name="incomeproof"
                    purpose={incomesproofValue?.document_type_reference}
                    pdfSize={7.5}
                    imageSize={7.5}
                    setRequestId={setRequestId}
                    requestId={requestId}
                  />
                </>
              </div>
            </div>
          </div>

          <div className={uploadStyles.checkBoxSection}>
            <div className={uploadStyles.checkBoxDiv}>
              <FormGroup>
                <FormControlLabel
                  sx={{ alignItems: "flex-start" }}
                  control={
                    <Checkbox
                      name="condition3"
                      sx={{
                        padding: "0px",
                        "&.Mui-checked": {
                          color: "#1F2937",
                        },
                      }}
                      checked={checkedOptions1}
                      onChange={(event) => {
                        const { checked } = event.target;
                        setCheckedOptions1(checked);
                      }}
                    />
                  }
                  label={
                    <span className={uploadStyles.label}>
                      I verify that the information supplied above is accurate,
                      truthful, and comprehensive to the best of my
                      understanding. Should any of the specified details be
                      discovered to be inaccurate or false, I acknowledge that I
                      may be held responsible.
                    </span>
                  }
                />
              </FormGroup>
            </div>
            <div className={uploadStyles.checkBoxDiv}>
              <FormGroup>
                <FormControlLabel
                  sx={{ alignItems: "flex-start" }}
                  control={
                    <Checkbox
                      name="condition3"
                      sx={{
                        padding: "0px",
                        "&.Mui-checked": {
                          color: "#1F2937",
                        },
                      }}
                      checked={checkedOptions2}
                      onChange={(event) => {
                        const { checked } = event.target;
                        setCheckedOptions2(checked);
                      }}
                    />
                  }
                  label={
                    <span className={uploadStyles.label}>
                      If there are any alterations to the provided information
                      in the future, I commit to notifying Firstock within a
                      period of 30 days from the date of such changes.
                    </span>
                  }
                />
              </FormGroup>
            </div>
          </div>

          <SucessSnackBar message={successMessage} />

          <SnackBar message={errorMessage} />

          <div className={uploadStyles.buttonStack}>
            <LoadingButton
              variant="contained"
              onClick={SubmitDetails}
              loading={loading}
              id="upLoadDocumentsContinueButton"
              className={uploadStyles.approveButton}
              disabled={
                !checkedOptions1 ||
                !checkedOptions2 ||
                disableContinueOption1 !== "Successfully uploaded the document"
              }
              sx={{ height: "50px" }}
            >
              Continue
            </LoadingButton>
          </div>
        </>
      </div>
    </div>
  );
}
